import React from 'react';
import { C } from '../tokens';
import Icon from './Icon';

export function Card({ children, style = {}, className = '' }) {
  return (
    <div className={className} style={{ background: C.w, borderRadius: 14, border: `1px solid ${C.bdr}`, ...style }}>
      {children}
    </div>
  );
}

export function Pill({ children, bg = C.pL, color = C.primary }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        padding: '3px 10px',
        borderRadius: 99,
        fontSize: 10,
        fontWeight: 700,
        background: bg,
        color,
        textTransform: 'uppercase',
        letterSpacing: '.04em',
      }}
    >
      {children}
    </span>
  );
}

export function SectionTitle({ sub, children, className = '' }) {
  return (
    <div className={`${className} dash-section-title`} style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-.03em', lineHeight: 1.15 }}>
        {children}
      </h2>
      {sub && <p style={{ color: C.t2, fontSize: 13, marginTop: 4 }}>{sub}</p>}
    </div>
  );
}

export function Btn({ children, primary, icon, style: s = {}, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '9px 18px',
        borderRadius: 12,
        border: primary ? 'none' : `1px solid ${C.bdr}`,
        background: primary ? C.primary : C.w,
        color: primary ? '#fff' : C.t1,
        fontSize: 13,
        fontWeight: 700,
        cursor: 'pointer',
        ...s,
      }}
    >
      {icon && <Icon name={icon} size={18} />}
      {children}
    </button>
  );
}

export function Breadcrumb({ items }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 12,
        fontWeight: 600,
        color: C.t3,
        marginBottom: 6,
        textTransform: 'uppercase',
        letterSpacing: '.08em',
      }}
    >
      {items.map((item, i) => (
        <React.Fragment key={i}>
          {i > 0 && <Icon name="chevron_right" size={14} />}
          <span style={{ color: i === items.length - 1 ? C.primary : C.t3 }}>{item}</span>
        </React.Fragment>
      ))}
    </div>
  );
}
